module.exports = __webpack_public_path__ + "img/No_game_instance_img.ed61c110.svg";